
import HttpUtil from "@/assets/js/HttpUtil";
import { EchartInitModel } from "@/assets/js/Model/InnerModel";
import Urls from "@/assets/js/Urls";
import lineChart from "@/components/Charts/LineChartCom.vue";
import Utils from "@/assets/js/Utils";
import box from "@/components/BoxCom.vue";
import pie from "@/components/Charts/PieCharCom.vue";
import rline from "@/components/Charts/RLineChartCom.vue";
import Vue from "vue";
export default Vue.extend({
  data() {
    return {
      orderStateChat: {} as any,
      orderTypeChat: [] as any,
      orderYearChat: [] as any,
      orderMonthChat: [] as any,
      orderRating: [] as any,
      orderList: [] as any,
      tran: Utils.getTran(),
    };
  },
  async mounted() {
    await this.getOrderStateChat();
    await this.getOrderTypeChat();
    await this.getOrderYearChat();
    await this.getOrderMonthChat();
    await this.getOrderRating();
    await this.getOrderList();
  },
  components: { box, pie, lineChart, rline },
  methods: {
    async getOrderList() {
      const data: any = {
        page: 0,
        pageSize: 100,
        conditions: [
          {
            field: "state",
            value: "3",
            conditionType: 3,
          },
        ],
      };
      const ret: any = await HttpUtil.XCHttpPost(Urls.GetOrders, data, true, false);
      this.orderList = ret.data;
    },
    async getOrderRating() {
      this.orderRating = await HttpUtil.XCHttpPost(
        Urls.GetOrderRatingChat,
        "",
        true,
        false
      );
    },
    async getOrderStateChat() {
      const req: any = await HttpUtil.XCHttpPost(Urls.GetOrderStateChat, "", true, false);
      this.orderStateChat = req;
      this.initorderStateChat();
    },
    async getOrderTypeChat() {
      const req: any = await HttpUtil.XCHttpPost(Urls.GetOrderTypeChat, "", true, false);
      this.orderTypeChat = req;
      this.initorderTypeChat();
    },

    async getOrderYearChat() {
      const req: any = await HttpUtil.XCHttpPost(Urls.GetOrderYearChat, "", true, false);
      this.orderYearChat = req;
      this.initorderYearChat();
    },
    async getOrderMonthChat() {
      const req: any = await HttpUtil.XCHttpPost(Urls.GetOrderMonthChat, "", true, false);
      this.orderMonthChat = req;
      this.initorderMonthChat();
    },
    initorderTypeChat() {
      const chart: any = this.$refs.orderTypeChat;
      let rdata: any[] = [];
      let labels: any[] = [];
      this.orderTypeChat.forEach((ele: any) => {
        rdata.push({ name: ele.typeName, value: ele.typeCount });
        labels.push(ele.typeName);
      });
      let opt: EchartInitModel = {
        Data: [
          {
            Name: "工单类型分析",
            Data: rdata,
          },
        ],
        LegendConfig: {
          top: 10,
          textStyle: {
            color: this.tran ? "#fff" : "#000",
          },
        },
        Labels: labels,
        Colors: ["rgb(243, 141, 10)"],
        Totate: true,
      };
      chart.setOption(opt);
    },
    initorderYearChat() {
      const chart: any = this.$refs.orderYearChat;
      let rdata: any[] = [];
      let labels: any[] = [];
      this.orderYearChat.forEach((ele: any) => {
        rdata.push({ name: ele.month, value: ele.count });
        labels.push(ele.month);
      });
      let opt: EchartInitModel = {
        Data: [
          {
            Name: "工单趋势分析",
            Data: rdata,
          },
        ],
        LegendConfig: {
          top: 10,
          textStyle: {
            color: this.tran ? "#fff" : "#000",
          },
        },
        Labels: labels,
        Colors: ["rgb(243, 141, 10)"],
        Totate: true,
      };
      chart.setOption(opt);
    },

    initorderMonthChat() {
      const chart: any = this.$refs.orderMonthChat;
      let rdata: any[] = [];
      let labels: any[] = [];
      this.orderMonthChat.forEach((ele: any) => {
        const day = ele.day.substr(0, 5);
        rdata.push({ name: day, value: ele.count });
        labels.push(day);
      });
      let opt: EchartInitModel = {
        Data: [
          {
            Name: "工单趋势分析",
            Data: rdata,
          },
        ],
        LegendConfig: {
          top: 10,
          textStyle: {
            color: this.tran ? "#fff" : "#000",
          },
        },
        Labels: labels,
        Colors: ["rgb(243, 141, 10)"],
        Totate: false,
      };
      chart.setOption(opt);
    },
    initorderStateChat() {
      const chart: any = this.$refs.orderStateChat;
      let opt: EchartInitModel = {
        Data: [
          {
            Name: "工单类型分析",
            Data: [
              { name: "未处理", value: this.orderStateChat.step1 },
              { name: "正在处理", value: this.orderStateChat.step2 },
              { name: "已完成", value: this.orderStateChat.step3 },
            ],
          },
        ],
        LegendConfig: {
          bottom: 10,
          textStyle: {
            color: this.tran ? "#fff" : "#000",
          },
        },
      };
      chart.setOption(opt);
    },
  },
});
